<ng-container>
  <div class="job-orders" *ngIf="localJobOrderDataStates.length; else empty">
    <table
      matSort
      mat-table
      [dataSource]="localJobOrderDataStates"
      (matSortChange)="sortData($event)"
    >
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterRowsToggle() : null"
            [checked]="masterAllSelected"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <mat-checkbox
            [checked]="dataState.isSelected"
            (change)="onDataStateCheckChanged(dataState)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Description</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <span class="fc-cell-text">{{ dataState.description }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Operation</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <span class="fc-cell-text">{{ dataState.operation }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="machineName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Machine name</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <span class="fc-cell-text">{{ dataState.machineName }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Start datetime</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <span class="fc-cell-text fc-mono">{{ dataState.startDate }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let myRowData; columns: columnsToDisplay"
        [ngClass]="{
          unchanged: myRowData.selectionState == 'UNCHANGED',
          added: myRowData.selectionState == 'ADDED',
          removed: myRowData.selectionState == 'REMOVED'
        }"
      ></tr>
    </table>
  </div>
</ng-container>

<ng-template #empty>
  <div class="container-empty">
    <span>No data state found</span>
  </div>
</ng-template>
